export default __webpack_public_path__ + "static/media/holy-sprit-with-ed-mobile1.cd8bdcb4.jpg";